module.exports = __webpack_public_path__ + "img/lavender.b4789b6d.webp";